import { NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  Signal
} from '@angular/core';
import { User } from '@angular/fire/auth';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterLink } from '@angular/router';
import { ProfileAvatarComponent } from '@vaki/shared/ui/profile-avatar';
import { Language } from '@vaki/shared/util/interfaces';

@Component({
  selector: 'lib-vakers-shell-ui-user-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    NgClass,
    MatMenuModule,
    ProfileAvatarComponent,
    MatButtonModule,
    RouterLink,
    MatIconModule,
    MatSlideToggleModule,
    FormsModule
  ],
  templateUrl: './vakers-shell-ui-user-menu.component.html',
  styleUrl: './vakers-shell-ui-user-menu.component.scss'
})
export class VakersShellUiUserMenuComponent {
  @Input() user: User | null = null;
  @Input({ required: true }) userLoggedIn!: Signal<boolean>;
  @Output() darkModeChange = new EventEmitter<boolean>();
  @Output() logout = new EventEmitter();
  @Input() languages: Language[] | undefined;
  @Input() currentLanguage: string | undefined | null;
  @Output() languageSelected = new EventEmitter<string>();
  @Input() currencies: string[] | null = [];
  @Input() currentCurrency: string | null = null;
  darkMode = false;
}
